var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const debounceAnimationFrame_1 = __importDefault(require("./debounceAnimationFrame"));
exports.default = debounceAnimationFrame_1.default;
